import React from 'react';

import { ForgotPasswordFormShared } from '@liscio/common';

import { validationSchema } from './validationSchema';
import { useTrackLoginEvent } from 'analytics/login/useTrackLoginEvent';
import { useForgotPassword } from 'fetch-utils/users/auth-hooks';

export const ForgotPasswordForm = () => {
  const trackLoginEvent = useTrackLoginEvent();
  const { forgotPasswordEmail, requestForgotPassword, requestMagicLink } =
    useForgotPassword();

  return (
    <ForgotPasswordFormShared
      appType="firm"
      validationSchema={validationSchema}
      trackLoginEvent={(eventName, properties) =>
        trackLoginEvent(eventName as Parameters<typeof trackLoginEvent>[0], properties)
      }
      forgotPasswordEmail={forgotPasswordEmail}
      requestForgotPassword={requestForgotPassword}
      requestMagicLink={requestMagicLink}
    />
  );
};
